import { render, staticRenderFns } from "./FormularioCadastro.vue?vue&type=template&id=996e1c2c&scoped=true&"
import script from "./FormularioCadastro.vue?vue&type=script&lang=js&"
export * from "./FormularioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./FormularioCadastro.vue?vue&type=style&index=0&id=996e1c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996e1c2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VSelect,VTextField})
